import { Tarifa } from './../../lookups/tarifa/tarifa';
import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChild, ChangeDetectorRef } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, InputComponent, QueryParameter, NumberInputComponentV3, UserService, ModalService, NotificationService } from 'yt-ng-framework';
import { FakDokumentStavka } from './fak-dokument-stavka';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { VrstaStavkiView } from '../vrsta-stavki/vrsta-stavki-view';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as var_config from '../../var_config';
import { FakturaService } from 'src/app/fak.bl/faktura/faktura.service';
import { DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-fak-dokument-stavka-update',
  templateUrl: './fak-dokument-stavka-update.component.html'
})
export class FakDokumentStavkaUpdateComponent
 extends BaseUpdateComponent<FakDokumentStavka>
 implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  aktuelnaStopa: number=0;
  cena: number=0;
  osnovica: number=0;
  kolicina: number=0;
  cenaUValuti : number = null;
  rabatUValuti : number = null;
  rabatProc : number = null;
 // debag:boolean=false;
  varConfig=var_config;
  ino: boolean = false;
  isAvans: boolean = false;
  idJM: number = null;
  // idManual: number=null;
  pretplacenNaPromene:boolean=false;

  private kolicinaValueChangeSubscription: Subscription;

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected fakturaService: FakturaService,
    protected decimalPipe: DecimalPipe,
    protected userService: UserService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService, modalService);

  }
  

  @ViewChild('txtOpis', { static: true }) txtOpis: InputComponent;
  @ViewChild('niv3Cena', { static: false }) niv3Cena: NumberInputComponentV3;
  @ViewChild('niv3CenaUValuti', { static: false }) niv3CenaUValuti: NumberInputComponentV3;
  @ViewChild('niv3CenaIno', {static: false}) niv3CenaIno: NumberInputComponentV3;

  rbItems=[];  

  identifikatorKlasifikacije=[
    {
      ID: 'PDV-RS-OBJ',
      Name: 'PDV-RS-OBJ'
    }
  ];
  
  TarifaItems;

  ngOnInit() {
    super.ngOnInit();

    this.ino=this.modelData.MainList.ModelName=="FakDokumentStavkaIzvoz";

    // 01.12.2023
    this.baseFormGroup.get('CenaSaPDV').disable();
    this.baseFormGroup.get('CenaSaPDV').updateValueAndValidity();
    this.baseFormGroup.get('OsnovicaStavke').disable();
    this.baseFormGroup.get('OsnovicaStavke').updateValueAndValidity();
    if (this.ino){      
      this.baseFormGroup.get('OsnovicaStavkeUValuti').disable();
      this.baseFormGroup.get('OsnovicaStavkeUValuti').updateValueAndValidity();    
      this.baseFormGroup.get('RabatVred').disable();
      this.baseFormGroup.get('RabatVred').updateValueAndValidity();
      this.baseFormGroup.get('Cena').disable();
      this.baseFormGroup.get('Cena').updateValueAndValidity();
    } 
    
    this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
    // this.saveInitialControlDisabledStatus();

    

    this.addValidatorToFc('VrstaStavkiID', Validators.required, 'required', 'FAKDOKUMENTSTAVKA.VRSTASTAVKI.VALIDATION.REQUIRED');
    this.addValidatorToFc('TarifaID', Validators.required, 'required', 'FAKDOKUMENTSTAVKA.TARIFA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Opis', Validators.required, 'required', 'FAKDOKUMENTSTAVKA.OPIS.VALIDATION.REQUIRED');
    this.addValidatorToFc('Kolicina', Validators.required, 'required', 'FAKDOKUMENTSTAVKA.KOLICINA.VALIDATION.REQUIRED');
    this.addValidatorToFc('Cena',Validators.required, 'required', 'FAKDOKUMENTSTAVKA.CENA.VALIDATION.REQUIRED');
    // this.addValidatorToFc("Opis", Validators.maxLength(1000), "maxlength", "FAKDOKUMENTSTAVKA.OPIS.VALIDATION.MAXLENGHT");
    this.addValidatorToFc('JedinicaMereID', Validators.required, 'required', 'FAKDOKUMENTSTAVKA.JM.VALIDATION.REQUIRED');
    this.addValidatorToFc('RobaUsluga', Validators.required, 'required', 'FAKDOKUMENTSTAVKA.ROBAUSLUGA.VALIDATION.REQUIRED');
    this.addValidatorToFc("RobaUsluga", Validators.maxLength(1), "maxlength", "FAKDOKUMENTSTAVKA.ROBAUSLUGA.VALIDATION.MAXLENGHT");
   
    this.addValidatorToFc('Kolicina', checkIfKolicina0('Kolicina',this), 'checkControlKolicina', 'FAKDOKUMENTSTAVKA.KOLICINA.VALIDATION.REQUIRED');
    this.addValidatorToFc('RabatProc', Validators.max(100), 'max', 'FAKDOKUMENTSTAVKA.RABATPROC.VALIDATION.MAX');
    

    this.IDProcessed
    .subscribe((value) => {

        if (value){
          // this.baseInlineContainer.baseInlineUpdateComponent.baseUpdateComponent.saveInitialControlDisabledStatus()

          if (this.Parameters && this.Parameters.get(1))
            this.isAvans = this.Parameters.get(1).get(0).Value["GenericName"] == "iz_avans";
            
          if (this.Parameters && this.Parameters.get(5) && this.niv3Cena){
            let brojDecimala = this.Parameters.get(5).get(0).Value;
            this.niv3Cena.FormatString = "1."+brojDecimala+"-"+brojDecimala;
            this.niv3Cena.displayValue = this.decimalPipe.transform(this.niv3Cena.value, this.niv3Cena.FormatString, this.userService.GetLocaleString());
            this.changeDetectorRef.markForCheck();
          }

          if (this.Parameters && this.Parameters.get(5) && this.niv3CenaUValuti){
            let brojDecimala = this.Parameters.get(5).get(0).Value;
            this.niv3CenaUValuti.FormatString = "1."+brojDecimala+"-"+brojDecimala;
            this.niv3CenaUValuti.displayValue = this.decimalPipe.transform(this.niv3CenaUValuti.value, this.niv3CenaUValuti.FormatString, this.userService.GetLocaleString());
            this.changeDetectorRef.markForCheck();
          }

          if (this.Parameters && this.Parameters.get(5) && this.niv3CenaIno){
            let brojDecimala = this.Parameters.get(5).get(0).Value;
            this.niv3CenaIno.FormatString = "1."+brojDecimala+"-"+brojDecimala;
            this.niv3CenaIno.displayValue = this.decimalPipe.transform(this.niv3CenaIno.value, this.niv3CenaIno.FormatString, this.userService.GetLocaleString());
            this.changeDetectorRef.markForCheck();
          }

          if (!this.pretplacenNaPromene)
          {
            this.pretplacenNaPromene=true;
            if (this.ino)
            {
              this.kolicinaValueChangeSubscription=this.baseFormGroup.get("Kolicina").valueChanges.subscribe((value) => {
                this.osveziVrednostPreRabataStavke(); 4
                this.osveziRabat();
                // ino
                this.osveziVrednostPreRabataStavkeUValuti();  1
                this.osveziRabatUValuti();
              });
              this.baseFormGroup.get("RabatProc").valueChanges.subscribe((value) => {              
                this.osveziRabatStavkePoProc(); 11
                //ino
                this.osveziRabatStavkeUValutiPoProc();  10
              });
              this.baseFormGroup.get("RabatStavkeUValuti").valueChanges.subscribe((value) => {
                this.osveziOsnovicaStavkeUValuti(); 18
              });
              this.baseFormGroup.get("RabatVredUValuti").valueChanges.subscribe((value) => {
                this.osveziRabatUValuti();
                this.osveziRabat();
              });
              this.baseFormGroup.get("OsnovicaStavkeUValuti").valueChanges.subscribe((value) => {
                this.osveziVrednostStavkeUValuti(); 19
                this.osveziPdvStavkeUValuti(); 20
              });
              this.baseFormGroup.get("CenaUValuti").valueChanges.subscribe((value) => {
                this.osveziVrednostPreRabataStavkeUValuti();  23
                this.osveziRabatUValuti();              
                this.osveziCena(); 21
                this.osveziRabat();
              })
              this.baseFormGroup.get("VrednostPreRabataStavkeUValuti").valueChanges.subscribe((value) => {
                this.osveziOsnovicaStavkeUValuti(); 24
              });
              this.baseFormGroup.get("PdvStavkeUValuti").valueChanges.subscribe((value) => {
                this.osveziVrednostStavkeUValuti(); 25
              });

              // this.baseFormGroup.get("TarifaID").valueChanges.subscribe((value) => {
              //   this.osveziPdvStavke(); 27
              //   // ino
              //   this.osveziPdvStavkeUValuti();  26   
              // });
              const tarifaIDControl = this.baseFormGroup.get('TarifaID');
              if (tarifaIDControl) {
                tarifaIDControl.valueChanges
                  .pipe(takeUntil(this.destroy$))
                  .subscribe((value) => {
                    this.osveziPdvStavke(); 27
                    // ino
                    this.osveziPdvStavkeUValuti();  26   
                  });
              }

              // this.baseFormGroup.get("RabatTip").valueChanges.subscribe((value) => {
              //   this.osveziRabatUValuti();
              //   this.osveziRabat();
              // });
              const rabatTipControl = this.baseFormGroup.get('RabatTip');
              if (rabatTipControl) {
                rabatTipControl.valueChanges
                  .pipe(takeUntil(this.destroy$))
                  .subscribe((value) => {
                    this.osveziRabatUValuti();
                    this.osveziRabat(); 
                  });
              }

            }
            else
            {
              this.kolicinaValueChangeSubscription=this.baseFormGroup.get("Kolicina").valueChanges.subscribe((value) => {
                this.osveziVrednostPreRabataStavke(); 4
                this.osveziRabat();
              });
              
              // this.baseFormGroup.get("RabatProc").valueChanges.subscribe((value) => {
              //   this.osveziRabatStavkePoProc(); 11
              // });
              const rabatProcControl = this.baseFormGroup.get('RabatProc');
              if (rabatProcControl) {
                rabatProcControl.valueChanges
                  .pipe(takeUntil(this.destroy$))
                  .subscribe((value) => {
                    this.osveziRabatStavkePoProc(); 11
                });
              }              
            }
  
            // this.baseFormGroup.get("Cena").valueChanges.subscribe((value) => {
            //   this.osveziVrednostPreRabataStavke(); 7
            //   this.osveziCenaSaPDV(); 9
            //   this.osveziRabat();            
            // });
            const cenaControl = this.baseFormGroup.get('Cena');
            if (cenaControl) {
              cenaControl.valueChanges
                .pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                  this.osveziVrednostPreRabataStavke(); 7
                  this.osveziCenaSaPDV(); 9
                  this.osveziRabat();
                });
            }

            // this.baseFormGroup.get("VrednostPreRabataStavke").valueChanges.subscribe((value) => {
            //   this.osveziOsnovicaStavke();  15
            // });
            const vrednostPreRabataStavkeControl = this.baseFormGroup.get('VrednostPreRabataStavke');
            if (vrednostPreRabataStavkeControl) {
              vrednostPreRabataStavkeControl.valueChanges
                .pipe(takeUntil(this.destroy$))
                .subscribe((value) => {
                  this.osveziOsnovicaStavke();  15
                });
            }

            this.baseFormGroup.get("RabatVred").valueChanges.subscribe((value) => {
              this.osveziRabat();
              this.osveziCenaSaPDV(); 13
            });
            this.baseFormGroup.get("RabatStavke").valueChanges.subscribe((value) => {
              this.osveziOsnovicaStavke();  14
            });
            this.baseFormGroup.get("TarifaID").valueChanges.subscribe((value) => {
              this.osveziPdvStavke(); 27
              this.osveziCenaSaPDV();
            });
            this.baseFormGroup.get("PdvStavke").valueChanges.subscribe((value) => {
              this.osveziVrednostStavke(); 28
            });
            this.baseFormGroup.get("OsnovicaStavke").valueChanges.subscribe((value) => {
              this.osveziPdvStavke(); 29
              this.osveziVrednostStavke();
            });
            this.baseFormGroup.get("RabatTip").valueChanges.subscribe((value) => {
              this.osveziRabat();
            });
          }

         
          
        if (value && this.Item.ID  == -1) {  
          




          //preraditi zbog avansa da bude ponuđena količina 1 i JM kom
          if (this.Parameters && this.Parameters.get(1)){
            if (this.isAvans){     
              this.baseDataService.Get('jedinicaMere','GetIDBySymbol',[new QueryParameter('symbol', 'kom')],null)
              .subscribe(idJM => {
                this.idJM = Number(idJM);
                this.baseFormGroup.patchValue({Kolicina: 1, JedinicaMereID: this.idJM});
                this.baseFormGroup.get('Kolicina').updateValueAndValidity();
                this.baseFormGroup.get('JedinicaMereID').updateValueAndValidity();
              })       
            }
          }
          if (this.vrstaStavki) {
            const opisValue = this.vrstaStavki.Sifra === 'manual' ? '' : this.vrstaStavki.Naziv;
            this.baseFormGroup.patchValue({ Cena: this.vrstaStavki.Cena, Opis: opisValue, TarifaID: this.vrstaStavki.TarifaID, JedinicaMereID: this.vrstaStavki.JedinicaMereID, RobaUsluga: this.vrstaStavki.RobaUsluga });
            this.baseFormGroup.get('Cena').updateValueAndValidity();
            this.baseFormGroup.get('Opis').updateValueAndValidity();
            this.baseFormGroup.get('TarifaID').updateValueAndValidity();
            this.baseFormGroup.get('JedinicaMereID').updateValueAndValidity();
            this.baseFormGroup.get('RobaUsluga').updateValueAndValidity();
          }
        }
        else{
          let _tarifaId:number=this.baseFormGroup.get("TarifaID").value;
          if (_tarifaId){
            const foundItem = this.TarifaItems.find(item => item.ID === _tarifaId);
            if (foundItem){
              if (foundItem.AktuelnaStopa == 0){
                this.baseFormGroup.get('IdentifikatorKlasifikacije').setValue(null);
                this.baseFormGroup.get('IdentifikatorKlasifikacije').disable();
                this.baseFormGroup.get('IdentifikatorKlasifikacije').updateValueAndValidity();
              }
              else{
                this.baseFormGroup.get('IdentifikatorKlasifikacije').enable();
                this.baseFormGroup.get('IdentifikatorKlasifikacije').updateValueAndValidity();
              }
              this.baseFormGroup.get('CenaSaPDV').disable();
              this.baseFormGroup.get('CenaSaPDV').updateValueAndValidity();
              this.baseFormGroup.get('OsnovicaStavke').disable();
              this.baseFormGroup.get('OsnovicaStavke').updateValueAndValidity();
              if (this.ino){      
                this.baseFormGroup.get('OsnovicaStavkeUValuti').disable();
                this.baseFormGroup.get('OsnovicaStavkeUValuti').updateValueAndValidity();    
                this.baseFormGroup.get('RabatVred').disable();
                this.baseFormGroup.get('RabatVred').updateValueAndValidity();
                this.baseFormGroup.get('Cena').disable();
                this.baseFormGroup.get('Cena').updateValueAndValidity();
              } 
              this.disabledControlsState = this.mapDisabledState(this.baseFormGroup);
          }
        }
      }
    }
      })

    // this.ino = this.Parameters.get(2) != undefined && Number(this.Parameters.get(2).get(0).Value) != 0 ? true : false;
    setTimeout(() => {
      this.translateService.get(['VRSTASTAVKI.ROBA.SINGULAR', 'VRSTASTAVKI.USLUGA.SINGULAR'])
        .subscribe(translate => {
            this.rbItems=[
                {
                    Name : translate['VRSTASTAVKI.ROBA.SINGULAR'],
                    Value : 'R'
                },
                {
                    Name : translate['VRSTASTAVKI.USLUGA.SINGULAR'],
                    Value : 'U'
                }
            ];
                                
        });
    }, 0);
   

  } 

  ngOnDestroy(){
    super.ngOnDestroy();
    if (this.kolicinaValueChangeSubscription)
    {
      this.kolicinaValueChangeSubscription.unsubscribe();
    }

    this.destroy$.next(); // Emituje signal za završetak pretplata
    this.destroy$.complete(); // Završava Subject
  }

  osveziVrednostPreRabataStavke(){
    if (this.baseFormGroup.get("Kolicina").value==0 && this.baseFormGroup.get("Cena").value==0)
      return
    var _vrednostPreRabataStavke: number=null;
    _vrednostPreRabataStavke=this.fakturaService.dajVrednostPreRabataStavke(
      this.baseFormGroup.get("Kolicina").value
      , this.baseFormGroup.get("Cena").value
    );
    if (_vrednostPreRabataStavke != null)
      this.baseFormGroup.get("VrednostPreRabataStavke").patchValue(_vrednostPreRabataStavke);
  }
  osveziRabatStavkePoProc(){
    if (this.baseFormGroup.get("RabatTip").value==0)
    {
      var _rabatStavke: number=null;
      _rabatStavke=this.fakturaService.dajRabatStavkeProc(
        this.baseFormGroup.get("Kolicina").value
        , this.baseFormGroup.get("Cena").value
        , this.baseFormGroup.get("RabatProc").value
      );
       if (_rabatStavke != null){
        this.baseFormGroup.get("RabatStavke").patchValue(_rabatStavke);
        this.baseFormGroup.get("RabatStavke").updateValueAndValidity();
       }
    }

  }

  osveziRabatStavkePoVred(){
    var _rabatStavke: number=null;
    // let _rabatProc: number = null;

    _rabatStavke=this.fakturaService.dajRabatStavkeVred(
      this.baseFormGroup.get("Kolicina").value
      , this.baseFormGroup.get("RabatVred").value
    );
     if (_rabatStavke != null){
      this.baseFormGroup.get("RabatStavke").patchValue(_rabatStavke);   
      this.baseFormGroup.get("RabatStavke").updateValueAndValidity();
     }      
  }

  osveziOsnovicaStavke(){
    var _osnovicaStavke:number=null;
    _osnovicaStavke=this.fakturaService.dajOsnovicaStavke(
      this.baseFormGroup.get("VrednostPreRabataStavke").value
      , this.baseFormGroup.get("RabatStavke").value
    );
    if (_osnovicaStavke != null)
      this.baseFormGroup.get("OsnovicaStavke").patchValue(_osnovicaStavke);
  }
  osveziPdvStavke(){
    let _tarifaId:number=this.baseFormGroup.get("TarifaID").value
    if (_tarifaId){
      const foundItem = this.TarifaItems.find(item => item.ID === _tarifaId);
      if (foundItem){
        var _pdvStavka:number=null;
        _pdvStavka=this.fakturaService.dajPdvStavke(
          this.baseFormGroup.get("OsnovicaStavke").value
          , foundItem.AktuelnaStopa
        );
        if (_pdvStavka != null)
          this.baseFormGroup.get("PdvStavke").patchValue(_pdvStavka);
      }

    }
  }
  osveziVrednostStavke(){
    var _vrednostStavke:number=null;
    _vrednostStavke=this.fakturaService.dajVrednostStavke(
      this.baseFormGroup.get("OsnovicaStavke").value
      , this.baseFormGroup.get("PdvStavke").value      
    );
    if (_vrednostStavke != null)
      this.baseFormGroup.get("VrednostStavke").patchValue(_vrednostStavke);
  }
  TarifaGetItems(items){
    this.TarifaItems=items;
  }

// Ino
  osveziVrednostPreRabataStavkeUValuti(){
    if (this.baseFormGroup.get("Kolicina").value==0 && this.baseFormGroup.get("CenaUValuti").value==0)
      return
    var _vrednostPreRabataStavke: number=null;
    _vrednostPreRabataStavke=this.fakturaService.dajVrednostPreRabataStavke(
      this.baseFormGroup.get("Kolicina").value
      , this.baseFormGroup.get("CenaUValuti").value
    );
    if (_vrednostPreRabataStavke != null)
      this.baseFormGroup.get("VrednostPreRabataStavkeUValuti").patchValue(_vrednostPreRabataStavke);
  }
  osveziRabatStavkeUValutiPoProc(){
    if (this.baseFormGroup.get("RabatTip").value==0)
    {
      var _rabatStavke: number=null;
      _rabatStavke=this.fakturaService.dajRabatStavkeProc(
        this.baseFormGroup.get("Kolicina").value
        , this.baseFormGroup.get("CenaUValuti").value
        , this.baseFormGroup.get("RabatProc").value
      );
      if (_rabatStavke != null){
        this.baseFormGroup.get("RabatStavkeUValuti").patchValue(_rabatStavke);
        this.baseFormGroup.get("RabatStavkeUValuti").updateValueAndValidity();
      }
    }
  }
  osveziRabatStavkeUValutiPoVred(){
    var _rabatStavke: number=null;
    _rabatStavke=this.fakturaService.dajRabatStavkeVred(
      this.baseFormGroup.get("Kolicina").value
      , this.baseFormGroup.get("RabatVredUValuti").value
    );
     if (_rabatStavke != null){
      this.baseFormGroup.get("RabatStavkeUValuti").patchValue(_rabatStavke);
      this.baseFormGroup.get("RabatStavkeUValuti").updateValueAndValidity();
     }
      
  }
  osveziOsnovicaStavkeUValuti(){
    var _osnovicaStavke:number=null;
    _osnovicaStavke=this.fakturaService.dajOsnovicaStavke(
      this.baseFormGroup.get("VrednostPreRabataStavkeUValuti").value
      , this.baseFormGroup.get("RabatStavkeUValuti").value
    );
    if (_osnovicaStavke != null)
      this.baseFormGroup.get("OsnovicaStavkeUValuti").patchValue(_osnovicaStavke);
  }
  osveziVrednostStavkeUValuti(){
    var _vrednostStavke:number=null;
    _vrednostStavke=this.fakturaService.dajVrednostStavke(
      this.baseFormGroup.get("OsnovicaStavkeUValuti").value
//      , this.baseFormGroup.get("PdvStavke").value      
      , this.baseFormGroup.get("PdvStavkeUValuti").value      
    );
    if (_vrednostStavke != null)
      this.baseFormGroup.get("VrednostStavkeUValuti").patchValue(_vrednostStavke);
  }

//09.10.2023
//Sneža, 13.10.2023
  osveziCenaSaPDV(){
    let _tarifaId:number=this.baseFormGroup.get("TarifaID").value
    if (_tarifaId){
      const foundItem = this.TarifaItems.find(item => item.ID === _tarifaId);
      if (foundItem){
        let _cenaSaPDV : number = 0;

        _cenaSaPDV = this.fakturaService.dajCenaSaPdv(
          this.baseFormGroup.get("Cena").value
          , this.baseFormGroup.get("RabatProc").value
          , foundItem.AktuelnaStopa, this.baseFormGroup.get('RabatTip').value
          , this.baseFormGroup.get('RabatVred').value
        )

        if(_cenaSaPDV != null)
          this.baseFormGroup.get("CenaSaPDV").patchValue(_cenaSaPDV);
        }
      }
  }
  osveziRabatVred(){
    let _rabatVred: number = null;
    const _RabatTip=this.baseFormGroup.get('RabatTip').value;
    if (_RabatTip == 0)   
    {
      // this.baseFormGroup.get("RabatProc").updateValueAndValidity();

      // if (!this.ino){
        _rabatVred = this.fakturaService.dajRabatVredPoJM(
        this.baseFormGroup.get("Cena").value, this.baseFormGroup.get("RabatProc").value)     
      
        if(_rabatVred != null && _rabatVred != this.baseFormGroup.get("RabatVred").value){
          this.baseFormGroup.get("RabatVred").patchValue(_rabatVred);
          this.baseFormGroup.get("Rabat").patchValue({ Type: 0, PValue: this.baseFormGroup.get("RabatProc").value, VValue: _rabatVred });
        }
       

    }   
  }

  osveziPdvStavkeUValuti(){
    let _tarifaId:number=this.baseFormGroup.get("TarifaID").value
    if (_tarifaId){
      const foundItem = this.TarifaItems.find(item => item.ID === _tarifaId);
      if (foundItem){
        var _pdvStavka:number=null;
        _pdvStavka=this.fakturaService.dajPdvStavke(
          this.baseFormGroup.get("OsnovicaStavkeUValuti").value
          , foundItem.AktuelnaStopa
        );
        if (_pdvStavka != null)
//          this.baseFormGroup.get("PdvStavke").patchValue(_pdvStavka);
          this.baseFormGroup.get("PdvStavkeUValuti").patchValue(_pdvStavka);
      }

    }
  }
  osveziCena(){
    let _cena : number = null;
    let _kurs : number = Number(this.Parameters.get(2).get(0).Value);
    let _brojDecimala : number = Number(this.Parameters.get(5).get(0).Value)
    _cena = this.fakturaService.dajRSDCenu(
      this.baseFormGroup.get("CenaUValuti").value,
      _kurs,
      _brojDecimala
    )
    if (_cena != null)
      this.baseFormGroup.get("Cena").patchValue(_cena);
  }

  osveziRabat(){
    if (this.baseFormGroup.get("RabatTip").value==0){
      this.osveziRabatStavkePoProc(); 8
      this.osveziRabatVred();
    }            
    else{              
      this.osveziRabatStavkePoVred(); 12
      this.osveziRabatProcAkoJePoVred();    
      if (this.ino)
        this.osveziRabatVredZbogInoRabatVredUValuti(); 
    }    
  }

  osveziRabatProcAkoJePoVred(){
    if (this.baseFormGroup.get("RabatTip").value==1){
      // this.baseFormGroup.get("RabatVred").updateValueAndValidity();
      let _rabatProc : number = null;
      _rabatProc = this.fakturaService.dajRabatProc(
        !this.ino ? this.baseFormGroup.get("RabatVred").value : this.baseFormGroup.get("RabatVredUValuti").value
        , !this.ino ? this.baseFormGroup.get("Cena").value : this.baseFormGroup.get("CenaUValuti").value)
      if (_rabatProc != null && _rabatProc != this.baseFormGroup.get("RabatProc").value)
      {
        this.baseFormGroup.get("RabatProc").patchValue(_rabatProc); 
        if (!this.ino)
          this.baseFormGroup.get("Rabat").patchValue({ Type: 1, PValue: _rabatProc, VValue: this.baseFormGroup.get('RabatVred').value });
        else
          this.baseFormGroup.get("RabatUValuti").patchValue({ Type: 1, PValue: _rabatProc, VValue: this.baseFormGroup.get('RabatVredUValuti').value });
      } 
    }
  }

  osveziRabatUValuti(){
    if (this.baseFormGroup.get("RabatTip").value==0){
      this.osveziRabatStavkeUValutiPoProc(); 
      this.osveziRabatVredUValuti();
    }            
    else{              
      this.osveziRabatStavkeUValutiPoVred(); 
      this.osveziRabatProcAkoJePoVred();     
    }    
  }

  osveziRabatVredUValuti(){
    let _rabatVred: number = null;
    const _RabatTip=this.baseFormGroup.get('RabatTip').value;
    if (_RabatTip == 0)   
    {     
        _rabatVred = this.fakturaService.dajRabatVredPoJM(
          this.baseFormGroup.get("CenaUValuti").value, this.baseFormGroup.get("RabatProc").value)     
        
        if(_rabatVred != null && _rabatVred != this.baseFormGroup.get("RabatVredUValuti").value){
          this.baseFormGroup.get("RabatVredUValuti").patchValue(_rabatVred);
          this.baseFormGroup.get("RabatUValuti").patchValue({ Type: 0, PValue: this.baseFormGroup.get("RabatProc").value, VValue: _rabatVred });

        }
    }   
  }

  osveziRabatVredZbogInoRabatVredUValuti(){
    let _rabatVred: number = null;
    _rabatVred = this.fakturaService.dajRabatVredPoJM(
      this.baseFormGroup.get("Cena").value, this.baseFormGroup.get("RabatProc").value)     
    
      if(_rabatVred != null  && _rabatVred != this.baseFormGroup.get("RabatVred").value){
        this.baseFormGroup.get("RabatVred").patchValue(_rabatVred);
        // this.baseFormGroup.get("Rabat").patchValue({ Type: 0, PValue: this.baseFormGroup.get("RabatProc").value, VValue: _rabatVred });
      }
  }

  private vrstaStavki: VrstaStavkiView = new VrstaStavkiView();
  onVrstaStavkiSelect(value:VrstaStavkiView){
  if(value && this.Item.ID && ((value != this.vrstaStavki && value != null) || this.Item.ID == -1)){
  // if(value){
      let idJm = value.JedinicaMereID;
      if (this.isAvans)
        idJm = this.idJM;

      const opisValue = value.Sifra === 'manual' ? '' : value.Naziv;

      this.baseFormGroup.patchValue({Cena: this.formControlData && this.formControlData["CenaUValuti"].IsVisible ? 0 : value.Cena, Opis: opisValue, TarifaID: value.TarifaID, JedinicaMereID: idJm, RobaUsluga: value.RobaUsluga});
      this.baseFormGroup.get('Cena').updateValueAndValidity();
      this.baseFormGroup.get('Opis').updateValueAndValidity();
      this.baseFormGroup.get('TarifaID').updateValueAndValidity();
      this.baseFormGroup.get('JedinicaMereID').updateValueAndValidity();
      this.baseFormGroup.get('RobaUsluga').updateValueAndValidity();
     
      //this.txtOpis.focus();
      this.vrstaStavki = value;
    // }
  }
  else
    this.SavedItem = this.baseFormGroup.getRawValue(); 
  
  }

  //Sneža, 13.10.2023
  onTarifaSelect(value:Tarifa){
    if (value) {
      if (value.AktuelnaStopa == 0){
        this.baseFormGroup.get('IdentifikatorKlasifikacije').setValue(null);
        this.baseFormGroup.get('IdentifikatorKlasifikacije').disable();
        this.baseFormGroup.get('IdentifikatorKlasifikacije').updateValueAndValidity();
      }
      else{
        this.baseFormGroup.get('IdentifikatorKlasifikacije').enable();
        this.baseFormGroup.get('IdentifikatorKlasifikacije').updateValueAndValidity();
      }
      this.changeDetectorRef.markForCheck();
    } 
  }


  onCenaSelect(){
  }

  calculate(type){
  }



  
  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}

  onRebateChange(value){
    this.baseFormGroup.patchValue(
      { RabatTip: value.Type ? value.Type : 0,
        RabatProc: Number.isNaN(value.PValue) ? 0 : value.PValue, 
        RabatVred: Number.isNaN(value.VValue) ? 0 : value.VValue });
    this.baseFormGroup.updateValueAndValidity();
    // this.IzracunajCenuSaPDV();
  }

  onRebateValutaChange(value){
    // this.baseFormGroup.patchValue({ RabatProc: value.PValue, RabatVredPoJmUValuti: value.VValue, RabatTip: value.Type ? value.Type : 0 });
    // this.baseFormGroup.patchValue({ RabatTip: value.Type ? value.Type : 0, RabatProc: value.PValue, RabatVredUValuti: value.VValue });
    this.baseFormGroup.patchValue(
      { RabatTip: value.Type ? value.Type : 0,
        RabatProc: Number.isNaN(value.PValue) ? 0 : value.PValue,
        RabatVredUValuti: Number.isNaN(value.VValue) ? 0 : value.VValue });
    this.baseFormGroup.updateValueAndValidity();
    // this.IzracunajRabatUValuti(value.Type ? value.Type : 0);
  }

  additem()
  {
    super.AddItem()
    
  }

  onCenaUValutiSelect(){
   
  }

}

function checkIfKolicina0(kolicinaKey : string, mainThis: any){
  return (group: FormGroup): {[key : string]: any} =>{
      if (group){
          let _kolicina = group.parent.get(kolicinaKey) as FormControl;
          let kolicina : Number = _kolicina.value;

          if (kolicina == null)
              return null;

          if (kolicina == 0)
                  return { 
                      checkControlKolicina: true
                  };
          else
              return null;
              
          }
      } 
  }

  function rounding(number: number, precision: number): number{
    return Number((Math.round(Number(number + "e+" + precision)) +"e-" + precision));
  }
